import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './Watermark.css';

export const Watermark: React.FC = () => {
  const { user } = useAuth();
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!user) {
    return null;
  }

  // Directors and admins are exempt from the on-screen watermark. The processing
  // team — processor team lead + processor agents — is also exempt (per request).
  const WATERMARK_EXEMPT_ROLES = ['director', 'admin', 'processor_team_lead', 'processor_agent'];
  if (WATERMARK_EXEMPT_ROLES.includes(user.role)) {
    return null;
  }

  // Calculate how many lines we need based on screen size
  // For diagonal coverage, we need more lines than just height
  const diagonalDistance = Math.sqrt(dimensions.width ** 2 + dimensions.height ** 2);
  const lineSpacing = 50; // Space between lines
  const numberOfLines = Math.ceil(diagonalDistance / lineSpacing) + 10; // Extra for safety

  // Calculate repetitions based on screen width
  const avgEmailLength = user.email.length;
  const repetitionsNeeded = Math.ceil((dimensions.width * 2) / (avgEmailLength * 10)); // Rough calculation

  // Create repeated pattern of user email
  const createWatermarkText = () => {
    const email = user.email;
    const repeatedText = Array(repetitionsNeeded).fill(email).join('     •     ');
    return repeatedText;
  };

  return (
    <div className="watermark-container">
      <div className="watermark-content">
        {/* Create multiple diagonal lines of watermark text */}
        {Array.from({ length: numberOfLines }, (_, index) => (
          <div 
            key={index} 
            className="watermark-line"
            style={{
              top: `${index * lineSpacing}px`,
            }}
          >
            {createWatermarkText()}
          </div>
        ))}
      </div>
    </div>
  );
};